import React, { useState } from "react";
import { useTransition, animated } from "react-spring";

export const SecondAnswer_NOTSURE = ({
  formData,
  setForm,
  navigation,
  step,
}) => {
  const [error, setError] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-start mt-24 h-full">
        {transition((style, item) =>
          item ? (
            <animated.div
              style={style}
              className="mx-auto flex flex-col justify-start"
            >
              <div className="flex justify-end py-4 pb-8">
                <button
                  className="bg-gray-light py-1 px-14 text-grey-eighty text-md transition-all w-58 cursor-pointer"
                  onClick={() => navigation.go(0)}
                >
                  Start Over
                </button>
              </div>
              <div className="text-center text-xl bg-gray-200 p-4 rounded">
                <p>
                  Please contact our Loan Servicing Department directly so they
                  can advise who to make your payments to. You can email them
                  at:{" "}
                  <a
                    target="_blank"
                    className="text-blue-complimentary hover:text-blue-dark transition-all underline"
                    href="mailto:loanservicing@onetrustintl.com"
                  >
                    loanservicing@onetrustintl.com
                  </a>{""}.
                  In your email, please include your name, loan number, and
                  property address.
                </p>
              </div>
            </animated.div>
          ) : null
        )}
      </div>
    </div>
  );
};
